import React, { useEffect, useState, useRef } from 'react'
import { Button } from '../../../../../components'
import { getTotalAmt } from '../../../lib/onlpos-utils'
import { getPriceStr } from '../../../../../lib/utils'

export function CalBox(props) {
  const { prcFields, setPrcFields } = props

  const onClickNum = (value) => {
    alert("금액 변경은 나중에...")

    /** 
     * @TODO 결제금액변경
     *  1. receivedAmt 변경 처리
     *  2. payedAmt - 기결제 금액 처리
     */
    // setPrcFields((pre) => {
    //   let newAmt = pre.receivedAmt
    //   if (value === 'del') {
    //     newAmt = '0'
    //   } else {
    //     newAmt += value
    //     console.log(newAmt)
    //   }
    //   return { ...pre, receivedAmt: parseInt(newAmt).toString() }
    // })
  }

  const allProps = {
    ...props,
    fields: prcFields,
    setFields: setPrcFields,
    onClickNum,
  }

  const styles = {
    wrap: {
      width: '100%',
      display: 'flex',
      marginTop: 15,
      justifyContent: 'space-between',
    },
  }

  return (
    <div style={styles.wrap}>
      <FormBox {...allProps} />
      <Calculator {...allProps} />
    </div>
  )
}

function FormBox(props) {
  const { fields } = props

  const inputNames = {
    totalAmt: '총 금액',
    discountAmt: '할인금액',
    payAmt: '결제할 금액',
    receivedAmt: '받은 금액',
    payedAmt: '기결제 금액',
    changeAmt: '거스름돈',
    supplyAmt: '공급가액',
    vatAmt: '부가세액',
  }

  useEffect(() => {
    document.getElementById('receivedAmt').focus()
  }, [])

  const styles = {
    wrap: { flex: 1 },
  }

  return (
    <div style={styles.wrap}>
      {Object.keys(fields).map((name, i) => {
        return (
          <FormLine
            key={i + 'cal'}
            {...props}
            label={inputNames[name]}
            name={name}
            value={fields[name]}
            // onChange={(e) => {
            //   onClickNum(e.target.value.substring(e.target.value.length - 1))
            // }}
          />
        )
      })}
    </div>
  )
}

function FormLine(props) {
  const { label, gStyle, value, name, onClickNum } = props

  const readOnly = name !== 'receivedAmt'
  const bgColor = readOnly ? '#ddd' : 'white'

  const styles = {
    wrap: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: 5,
    },
    label: {
      flex: 2,
      ...gStyle.text,
      fontSize: '0.8rem',
      textAlign: 'right',
      paddingRight: 15,
    },
    inputEl: {
      flex: 1,
      width: '150px',
      height: 35,
      borderRadius: 3,
      backgroundColor: bgColor,
      border: '1px solid gray',
      paddingLeft: 5,
    },
  }

  return (
    <div style={styles.wrap}>
      {label && <p style={styles.label}>{label}</p>}
      <input
        id={name}
        style={styles.inputEl}
        name={name}
        value={getPriceStr(value)}
        onChange={(e) => {
          onClickNum(e.target.value.substring(e.target.value.length - 1))
        }}
        readOnly={readOnly}
      />
    </div>
  )
}

function Calculator(props) {
  const { onClickNum } = props
  const btns = [
    { name: '1' },
    { name: '2' },
    { name: '3' },
    { name: '4' },
    { name: '5' },
    { name: '6' },
    { name: '7' },
    { name: '8' },
    { name: '9' },
    { name: '0' },
    { name: '00' },
    { name: 'del' },
  ]

  const styles = {
    wrap: {
      flex: 1,
      backgroundColor: 'azure',
      paddingTop: 5,
    },
    innerWrap: {
      width: '95%',
      marginLeft: 'auto',
      marginRight: 'auto',
      // backgroundColor: 'red',
      display: 'flex',
      flexWrap: 'wrap',
    },
    btn: {
      marginLeft: 2,
      marginBottom: 2,
      width: 80,
      height: 80,
    },
  }

  return (
    // 화살표 &larr;

    <div style={styles.wrap}>
      <div style={styles.innerWrap}>
        {btns.map((btn, i) => {
          return (
            <Button
              style={styles.btn}
              key={i + 'btn'}
              variant="dark"
              onClick={() => onClickNum(btn.name)}
            >
              {btn.name === 'del' ? (
                <span style={{ ...props.gStyle.subtitle, color: 'white' }}>
                  &larr;
                </span>
              ) : (
                <span style={{ ...props.gStyle.subtitle, color: 'white' }}>
                  {btn.name}
                </span>
              )}
            </Button>
          )
        })}
      </div>
    </div>
  )
}
